/* eslint-disable react-hooks/exhaustive-deps */
import { consumirServicioEncirptacion } from "api";
import Page from "components/Page";
import ProgressSpinner from "components/PogressSpinners/ProgressSpinner";
import { emp, urlAutenticacionOkta, urlAuthSSOLogin, urlVerificarEmailOkta } from "constants/urls";
import {
  LOGIN_USER_TYPE,
  USER_TYPE_LOGIN,
  USER_TYPE_STORAGE_KEY,
} from "constants/USER_TYPES";
import useCustomRouter from "hooks/useCustomRouter";
import useCustomToast from "hooks/useCustomToasts";
import useQueryParams from "hooks/useQueryParams";
import React, { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { Alert, Col, Row } from "reactstrap";
import { loginFetchMex } from "redux/actions/aLogin";
import { encriptarContrasenia } from "utils/Encriptar";
import { InputContainer } from "../InputsMex/containers";
import { TextInput } from "../InputsMex/inputs";
import { emailRegex } from "../InputsMex/validaciones";
import "./login.scss";
import { IMG_BANNER_LOGIN_AGENTES } from "utils/constants";

const LoginMex = ({ loginError }) => {
  const { user, session, submited } = useQueryParams();

  const dispatch = useDispatch();
  const [isLocalUser, setIsLocalUser] = useState(!!session);

  const [verificandoCorreo, setVerificandoCorreo] = useState(false);

  const { addWarningToast } = useCustomToast();

  const methods = useForm({ mode: "onChange" });

  const history = useCustomRouter();

  const [visible, setVisible] = useState(loginError);

  const onDismiss = () => setVisible(false);

  useEffect(() => {
    setVisible(loginError);
  }, [loginError]);

  useEffect(() => {
    const userType = USER_TYPE_LOGIN[user];
    setIsLocalUser(userType === USER_TYPE_LOGIN.clientes);
    if (userType) {
      localStorage.setItem(USER_TYPE_STORAGE_KEY, userType);
    } else {
      addWarningToast("Debe seleccionar un usuario válido");
      history.push("/");
    }
  }, [user]);

  useEffect(() => {
    if (session && !submited) {
      history.push(`${history.getFullPath()}&submited=true`);
      onSubmit({
        correo: Buffer.from(session, "base64").toString(),
        contrasenia: "THIS_IS_A_USER_FROM_OKTA",
      });
    }
  }, []);

  useEffect(() => {
    if (submited && loginError) {
      addWarningToast("Ha ocurrido un problema al iniciar sesión");
    }
  }, [loginError]);


  const verificarCorreo = async (data) => {
    setVerificandoCorreo(true);
    try {
      const res = await consumirServicioEncirptacion(urlVerificarEmailOkta, {
        email: data?.correo,
        empresa: emp,
      });

      if (res?.transaccion) {
        if (!res?.autenticarOkta) {
          setIsLocalUser(!res?.autenticarOkta);
        } else {
          addWarningToast(res?.getMsg);
        }
      }
    } catch (error) { }
    setVerificandoCorreo(false);
  };

  const onSubmit = (data) => {
    if (isLocalUser) {
      return dispatch(
        loginFetchMex({
          cliUsuario: data.correo,
          cliPassword: encriptarContrasenia(data.contrasenia),
          carHash: "",
        })
      );
    }
    return verificarCorreo(data);
  };

  return (
    <Page>
      {user && (
        <div className='text-center text-mex mt-5 mb-5'>
          <h1 className='display-3'>
            {user === "clientes" && "Portal de clientes"}
            {user === "agentes" && "Portal de agentes y brokers"}
          </h1>
        </div>
      )}
      {
        user === LOGIN_USER_TYPE.AGENTES && (
          <Row className='justify-content-center'>
            <Col md={9} lg={8} xl={8}>
              <img src={IMG_BANNER_LOGIN_AGENTES} className="" style={{ width: "100%" }} alt="" loading="lazy" ></img>

            </Col>
          </Row>
        )
      }
      <Row className='justify-content-center'>
        <Col md={9} lg={7} xl={6}>
          <div className='card-login-mex'>
            <div className='card-login-mex-title'>
              <h2 className='login__card__title'>
                {user === "clientes" && "Consulta aquí tus pólizas"}
                {user === "agentes" && "Inicia sesión en AIG"}
              </h2>
            </div>
            {!session && (
              <div className='card-login-mex-frm'>
                <FormProvider {...methods}>
                  <form
                    noValidate
                    autoComplete='off'
                    onSubmit={methods.handleSubmit(onSubmit)}>
                    <Row>
                      {user === LOGIN_USER_TYPE.AGENTES && (
                        <div className='col-12 text-center'>
                          <h5 className='text-primary'>Eres usuario AIG</h5>
                          <div className='mx-4'>
                            {/* <button type='button' onClick={redireccionarOkta}></button> */}
                            <a
                              className='btn btn-block text-dark'
                              style={{
                                backgroundColor: "white",
                                border: "1px solid #2B7DE9",
                              }}
                              href={urlAutenticacionOkta}>
                              INICIAR SESIÓN CON OKTA
                            </a>
                          </div>
                        </div>
                      )}
                      {user === LOGIN_USER_TYPE.AGENTES && (
                        <div className='col-12 text-center'>
                          <div className='mx-4'>
                            <a
                              className='btn btn-block text-dark'
                              style={{
                                backgroundColor: "white",
                                border: "1px solid #2B7DE9",
                              }}
                              href={urlAuthSSOLogin}>
                              Eres Agente o Broker sigue por aquí
                            </a>
                          </div>
                        </div>
                      )}
                      <div className='col-12'>
                        <InputContainer label='Correo Electrónico' name='correo'>
                          <TextInput
                            inputProps={{
                              type: "email",
                              name: "correo",
                              placeholder: "juan.ma@aig.com",
                              autoComplete: "off",
                            }}
                            rules={{
                              required: "Este campo es obligatorio",
                              pattern: {
                                value: emailRegex,
                                message: "Ingrese un correo valido",
                              },
                            }}
                            onChangeFn={() => {
                              if (user === LOGIN_USER_TYPE.AGENTES) {
                                setIsLocalUser(false);
                              }
                            }}
                            disabled={verificandoCorreo}
                          />
                        </InputContainer>
                      </div>

                      {isLocalUser && (
                        <div className='col-12 text-left'>
                          <InputContainer label='Contraseña' name='contrasenia'>
                            <TextInput
                              inputProps={{
                                type: "password",
                                name: "contrasenia",
                                placeholder: "**************",
                              }}
                              rules={{
                                required: "Este campo es obligatorio",
                              }}
                            />
                          </InputContainer>

                          <div className='text-right mr-5'>
                            <Link
                              className='font-mex text-mex'
                              to='/recuperar-contrasenia'
                              style={{ fontSize: "19px" }}>
                              ¿Has olvidado tu contraseña?
                            </Link>
                          </div>
                        </div>
                      )}
                      <div className='col-12'>
                        <Alert color='danger' isOpen={visible} toggle={onDismiss}>
                          <p className='font-mex'>
                            Por favor verificar los datos ingresados
                          </p>
                        </Alert>
                      </div>

                      <div className='col-12'>
                        <div className='form-contenedor-type1'>
                          <button
                            id='btn-login-ingresar'
                            className='btn btn-primary btn-block'
                            type='submit'
                            disabled={verificandoCorreo}>
                            {isLocalUser && !verificandoCorreo && "INICIAR SESIÓN"}
                            {!isLocalUser && !verificandoCorreo && "VERIFICAR CORREO"}
                            {verificandoCorreo && "VERIFICANDO CORREO..."}
                          </button>
                        </div>
                      </div>

                      <div className='col-12 login__link__regresar'>
                        <Link to='/' className='regresar-login'>
                          Regresar
                        </Link>
                      </div>
                    </Row>
                  </form>
                </FormProvider>
              </div>
            )}
            {session && !loginError && (
              <div className='my-5'>
                <ProgressSpinner label='Ingresando...' />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Page>
  );
};

export default LoginMex;
